/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Recommendation for loan application
 */
export type AssessmentRecommendation = typeof AssessmentRecommendation[keyof typeof AssessmentRecommendation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssessmentRecommendation = {
  APPROVE: 'APPROVE',
  APPROVE_WITH_CONDITIONS: 'APPROVE_WITH_CONDITIONS',
  REFER: 'REFER',
  REJECT: 'REJECT',
} as const;
